/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const commonModule = require('@utils/common/commonModule');
const consumersModule = require('@utils/consumers/consumersModule');
const cookiesModule = require('@utils/cookies/cookiesModule');
const UtilitySelectorCookieService = require('./utilitySelectorCookieService');
const UtilitySelectorService = require('./utilitySelectorService');

const utilitySelectorModule = angular
    .module('enervee_utils.utility_selector', [
        commonModule.name,
        cookiesModule.name,
        consumersModule.name,
    ])
    .factory('UtilitySelectorCookieService', UtilitySelectorCookieService)
    .factory('UtilitySelectorService', UtilitySelectorService);

module.exports = utilitySelectorModule;